import { Serializer as JSONAPISerializer } from 'jsonapi-serializer';

export const UserSerializer = new JSONAPISerializer('user', {
  keyForAttribute: 'camelCase',
  attributes: ['email', 'mobilePhone', 'newsletterConsent'],
});
